<template>
  <section>
    <ChatBotView></ChatBotView>
  </section>
</template>

<script>
import ChatBotView from '@/views/ChatSinglePage/ChatBotView'
export default {
  name: 'ChatSinglePage',
  components: {
    ChatBotView
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/ChatBotPage.vue